import i18n from 'i18next';
import { sectionParams } from '../constants/section';
import { Section } from '../types/configurator';

export const getSectionParams = (section: Section) => {
	const result: string[][] = [];

	sectionParams.forEach((param) => {
		const value = param.calculate(section);
		if (value) {
			result.push([i18n.t(`sectionParams.${param.key}`), value]);
		}
	});

	return result;
};
